import { render, staticRenderFns } from "./GastroPreviewBowelCleanseForms.vue?vue&type=template&id=3b0a5ccb&scoped=true&"
import script from "./GastroPreviewBowelCleanseForms.vue?vue&type=script&lang=js&"
export * from "./GastroPreviewBowelCleanseForms.vue?vue&type=script&lang=js&"
import style0 from "./GastroPreviewBowelCleanseForms.vue?vue&type=style&index=0&id=3b0a5ccb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0a5ccb",
  null
  
)

export default component.exports